import { pipe, reject, either, isNil, isEmpty, map, when, is } from 'ramda'
import { $TSFixMe } from 'types/ts-migrate'
import { TPartyPayload } from './types'

export const getTaggablePartyId = (party: TPartyPayload): string => (party.person ?? party.company).id

export const rejectObjectEmptyOrNullValues = (obj: $TSFixMe) =>
  pipe(reject(either(isNil, isEmpty)), map(when(is(Object), rejectObjectEmptyOrNullValues)))(obj)
